import { createApp } from 'vue';
import JpgToPngConverter from '../Components/JpgToPngConverter.vue';

const root = document.getElementById('jpg-to-png-converter');
if (root) {
  createApp(JpgToPngConverter).mount('#jpg-to-png-converter');
}
